import {Sexe} from '@/shared/models';

export function initialFilter(value) {
    let key;
    switch (value) {
        case Sexe.MALE:
            key = 'shared.gender.male_initial';
            break;
        case Sexe.FEMALE:
            key = 'shared.gender.female_initial';
            break;
    }

    if(key) {
        return i18n.t(key);
    }
}